// extracted by mini-css-extract-plugin
export default {"cls1":"nhv6QOWxIy7V6etH4t0s","cls2":"ioi7KiXZ3_vvnLfWJ6vf nhv6QOWxIy7V6etH4t0s"};